import type { TFunction } from 'i18next'

import { INSURANCE_COVERAGES } from './api'

/**
 * A paper's name as the screens say it: a coverage by its line on the certificate
 * ("Cargo"), anything else by its type ("Operating authority"). One definition for the
 * documents panel and for every sentence that names a carrier's papers elsewhere, so a
 * line reads the same under the documents as beside the truck it holds back.
 */
export function paperName(type: string, t: TFunction): string {
  const coverage = INSURANCE_COVERAGES.find((candidate) => candidate.type === type)
  return coverage === undefined ? t(`documents.types.${type}`) : t(`documents.coverages.${coverage.key}`)
}
